import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/query-keys.js';
import { memberDemographicsApi } from '../lib/api.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Marketing
 * @graph-business 会員デモグラフィクス分析データを取得する react-query フック。
 * @graph-connects memberDemographicsApi.getDemographics [calls] 会員デモグラフィクス API
 */
export function useMemberDemographics() {
  return useQuery({
    queryKey: queryKeys.memberDemographics.all,
    queryFn: () => memberDemographicsApi.getDemographics(),
    staleTime: 5 * 60 * 1000,
  });
}
